import { graphql } from "@opensea/graphql"
import { ChainBadgeFragment } from "../../components/ChainBadge/ChainBadge.fragment"

export const ContextCurrencyFragment = graphql(
  `
    fragment ContextCurrency on Currency {
      contractAddress
      chainIdentifier
      usdPrice
      restrictSwapsToNativeTokens
      restrictSwapsToSameChain
      stats {
        marketCapUsd
        oneDay {
          priceChange
        }
      }
      symbol
      decimals
      name
      imageUrl
      isSwapDisabled
      warnings {
        featureId
      }
      chain {
        ...ChainBadge
      }
    }
  `,
  [ChainBadgeFragment],
)
